// "Share" buttons: the system share sheet where there is one (phones, Safari,
// Edge), otherwise the link is copied and a post opens on X. Markup:
//   <button data-share data-share-url="…" data-share-title="…" data-share-text="…">
export function installShare(): void {
  document.addEventListener('click', async (event) => {
    const button = (event.target as Element).closest<HTMLButtonElement>('[data-share]')
    if (!button) return
    const { shareUrl: url = location.href, shareTitle: title = document.title, shareText: text = '' } = button.dataset
    const label = button.textContent
    const done = (word: string) => {
      button.textContent = word
      setTimeout(() => (button.textContent = label), 1600)
    }
    if (navigator.share && (!navigator.canShare || navigator.canShare({ url, title, text }))) {
      try {
        await navigator.share({ url, title, text })
        done('Shared')
      } catch {
        // Dismissed: nothing to do.
      }
      return
    }
    try {
      await navigator.clipboard.writeText(`${text} ${url}`.trim())
      done('Link copied')
    } catch {
      done('Copy failed')
    }
    window.open(`https://x.com/intent/post?${new URLSearchParams({ text, url })}`, '_blank', 'noopener')
  })
}
